module.exports = __webpack_public_path__ + "static/media/paul.1f576e09.png";